import { call, put, takeLatest } from "redux-saga/effects";
import { uploadFile } from "shared-utility/store/utils/fileHelper";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
  , multipleObjectReturn
} from "shared-utility/store/utils/helpers";
import {
  getCompanySaga,
  GET_COMPANY_BY_ID
} from "store/state/companies";
import {
  downloadFile
} from "shared-utility/store/utils/downloadFile";

// ACTIONS

const getGuestCompanyId = () => localStorage.getItem("guestCompanyId");

export const GET_DEAL_NAMES = generateDefaultActions("GET_DEAL_NAMES");
export const getDealNames = payload => makePayload(GET_DEAL_NAMES.value, payload);
function* getDealNamesSaga() {
  const guestCompanyId = getGuestCompanyId();
  let url = "/dealNames";
  if (guestCompanyId) {
    url = `/dealNames/${guestCompanyId}`;
  }

  yield requestSaga(GET_DEAL_NAMES, url, "GET");
}

export const GET_DASHBOARD_DEALS = generateDefaultActions("GET_DASHBOARD_DEALS");
export const getDashboardDeals = payload => makePayload(GET_DASHBOARD_DEALS.value, payload);
function* getDashboardDealsSaga() {
  const guestCompanyId = getGuestCompanyId();
  let url = "/deal/dashboard/deals";
  if (guestCompanyId) {
    url = `/deal/dashboard/deals/${guestCompanyId}`;
  }

  yield requestSaga(GET_DASHBOARD_DEALS, url, "GET");
}

export const GET_DASHBOARD_FUND_NAMES = generateDefaultActions("GET_DASHBOARD_FUND_NAMES");
export const getDashboardFundNames = payload => makePayload(GET_DASHBOARD_FUND_NAMES.value, payload);
function* getDashboardFundNamesSaga() {
  const guestCompanyId = getGuestCompanyId();
  let url = "/fund/names";
  if (guestCompanyId) {
    url = `/fund/names/${guestCompanyId}`;
  }

  yield requestSaga(GET_DASHBOARD_FUND_NAMES, url, "GET");
}

export const UPDATE_DASHBOARD_FUND = generateDefaultActions("UPDATE_DASHBOARD_FUND");
export const updateDashboardFund = payload => makePayload(UPDATE_DASHBOARD_FUND.value, payload);
function* updateDashboardFundSaga(payload) {
  const url = `/funds/${payload.fund.id}`;
  const callback = handleCallback(payload);
  yield requestSaga(UPDATE_DASHBOARD_FUND, url, "PUT", payload);
  yield callback();
}

export const POST_DASHBOARD_FUND = generateDefaultActions("POST_DASHBOARD_FUND");
export const postDashboardFund = payload => makePayload(POST_DASHBOARD_FUND.value, payload);
function* postDashboardFundSaga(payload) {
  const url = "/funds";
  const callback = handleCallback(payload);
  yield requestSaga(POST_DASHBOARD_FUND, url, "POST", payload);
  yield callback();
}

export const POST_DASHBOARD_DEAL = generateDefaultActions("POST_DASHBOARD_DEAL");
export const postDashboardDeal = payload => makePayload(POST_DASHBOARD_DEAL.value, payload);
function* postDashboardDealSaga(payload) {
  const url = "/deals";
  const callback = handleCallback(payload);
  yield requestSaga(POST_DASHBOARD_DEAL, url, "POST", payload);
  yield callback();
}

export const DASHBOARD_IS_DOWNLOADING = {
  isDownloading: "DASHBOARD_IS_DOWNLOADING",
  /**
   * {isDownloading: boolean}
   */
  setIsDownloading: payload => ({ type: "DASHBOARD_IS_DOWNLOADING", payload })
};

/**
 * {dealIds: []}
 */
export const getDashboardDealPdfSummary = payload => makePayload(GET_DASHBOARD_PDF_DEAL_SUMMARY.value, payload);
export const GET_DASHBOARD_PDF_DEAL_SUMMARY = generateDefaultActions("GET_DASHBOARD_PDF_DEAL_SUMMARY");
function* getDashboardDealPdfSummarySaga(payload) {
  try {
    yield put(DASHBOARD_IS_DOWNLOADING.setIsDownloading({ isDownloading: true }));
    yield call(downloadFile, "downloadLoanSummaries", "POST", payload, 600000);
    yield put(GET_DASHBOARD_PDF_DEAL_SUMMARY.createSuccess(payload));
  } catch (error) {
    yield put(GET_DASHBOARD_PDF_DEAL_SUMMARY.createFailure(error));
  } finally {
    yield put(DASHBOARD_IS_DOWNLOADING.setIsDownloading({ isDownloading: false }));
  }
}

export const MAX_DEALS_IN_PDF_SUMMARY = generateDefaultActions("MAX_DEALS_IN_PDF_SUMMARY");
export const getMaxDealsInPdfSummary = () => makePayload(MAX_DEALS_IN_PDF_SUMMARY.value);
function* getMaxDealsInPdfSummarySaga() {
  yield requestSaga(MAX_DEALS_IN_PDF_SUMMARY, "/configItems/50931d3a-3c29-44f7-b261-734a0ffef401");
}

export const POST_COMPANY_BANNER_IMAGE = generateDefaultActions("POST_COMPANY_BANNER_IMAGE");
export const postCompanyBannerImage = payload => makePayload(POST_COMPANY_BANNER_IMAGE.value, payload);
function* postCompanyBannerImageSaga(sagaPayload) {
  const payload = {
    file: sagaPayload.file,
    url: `/company/${sagaPayload.companyId}/bannerImage`
  };
  const response = yield call(uploadFile, payload);
  yield put(POST_COMPANY_BANNER_IMAGE.createSuccess(response));
}

export const DELETE_COMPANY_BANNER_IMAGE = generateDefaultActions("DELETE_COMPANY_BANNER_IMAGE");
export const deleteCompanyBannerImage = payload => makePayload(DELETE_COMPANY_BANNER_IMAGE.value, payload);
function* deleteCompanyBannerImageSaga(payload) {
  yield requestSaga(DELETE_COMPANY_BANNER_IMAGE, `/company/${payload.companyId}/bannerImage`, "DELETE");
}

export const POST_COMPANY_LOGO_IMAGE = generateDefaultActions("POST_COMPANY_LOGO_IMAGE");
export const postCompanyLogoImage = payload => makePayload(POST_COMPANY_LOGO_IMAGE.value, payload);
function* postCompanyLogoImageSaga(sagaPayload) {
  const payload = {
    file: sagaPayload.file,
    url: `/company/${sagaPayload.companyId}/logoImage`
  };
  const response = yield call(uploadFile, payload);
  yield put(POST_COMPANY_LOGO_IMAGE.createSuccess(response));
}

export const DELETE_COMPANY_LOGO_IMAGE = generateDefaultActions("DELETE_COMPANY_LOGO_IMAGE");
export const deleteCompanyLogoImage = payload => makePayload(DELETE_COMPANY_LOGO_IMAGE.value, payload);
function* deleteCompanyLogoImageSaga(payload) {
  yield requestSaga(DELETE_COMPANY_LOGO_IMAGE, `/company/${payload.companyId}/logoImage`, "DELETE");
}

// REDUCER

const initialState = {
  dealNames: [],
  deals: [],
  funds: [],
  isDownloading: false,
  dealCompanies: []
};

export function dashboardReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_DEAL_NAMES.success:
      return multipleObjectReturn(state, ["dealNames", "dealCompanies"], [payload.result, payload.companies]);

    case GET_DASHBOARD_DEALS.success:
      return defaultReturn(state, payload.data, "deals");

    case GET_DASHBOARD_FUND_NAMES.success:
      return defaultReturn(state, payload.data, "funds");

    case UPDATE_DASHBOARD_FUND.success:
      ToastSuccess("Fund Update Successful");

      return defaultReturn(state);

    case POST_DASHBOARD_FUND.success:
      ToastSuccess("Fund Creation Successful");

      return defaultReturn(state);

    case POST_DASHBOARD_DEAL.success:
      ToastSuccess("Deal Creation Successful");

      return defaultReturn(state);

    case DASHBOARD_IS_DOWNLOADING.isDownloading:
      return { ...state, ...payload };

    case MAX_DEALS_IN_PDF_SUMMARY.success:
      return { ...state, maxDealsInPdfSummary: parseInt(payload.value, 10) };

    case MAX_DEALS_IN_PDF_SUMMARY.failure:
      ToastError("Could not prepare for PDF summary download");

      return { ...state, maxDealsInPdfSummary: null };

    case GET_DASHBOARD_PDF_DEAL_SUMMARY.success:
      ToastSuccess("Summary successfully generated");

      return defaultReturn(state);

    case GET_DASHBOARD_PDF_DEAL_SUMMARY.failure:
      ToastError("Summary failed to generate");

      return defaultReturn(state);

    case GET_DASHBOARD_DEALS.error:
    case GET_DEAL_NAMES.error:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case POST_COMPANY_BANNER_IMAGE.success:
      return { ...state, company: payload.company };

    case DELETE_COMPANY_BANNER_IMAGE.success:
      return { ...state, company: payload.company };

    case POST_COMPANY_LOGO_IMAGE.success:
      return { ...state, company: payload.company };

    case DELETE_COMPANY_LOGO_IMAGE.success:
      return { ...state, company: payload.company };

    case GET_COMPANY_BY_ID.success:
      return defaultReturn(state, payload, "company");

    default:
      return state;
  }
}

// SAGA

export function* dashboardSaga() {
  yield takeLatest(GET_DEAL_NAMES.value, getDealNamesSaga);
  yield takeLatest(GET_DASHBOARD_DEALS.value, getDashboardDealsSaga);
  yield takeLatest(GET_DASHBOARD_FUND_NAMES.value, getDashboardFundNamesSaga);
  yield takeLatest(UPDATE_DASHBOARD_FUND.value, updateDashboardFundSaga);
  yield takeLatest(POST_DASHBOARD_FUND.value, postDashboardFundSaga);
  yield takeLatest(MAX_DEALS_IN_PDF_SUMMARY.value, getMaxDealsInPdfSummarySaga);
  yield takeLatest(GET_DASHBOARD_PDF_DEAL_SUMMARY.value, getDashboardDealPdfSummarySaga);
  yield takeLatest(POST_DASHBOARD_DEAL.value, postDashboardDealSaga);
  yield takeLatest(POST_COMPANY_BANNER_IMAGE.value, postCompanyBannerImageSaga);
  yield takeLatest(DELETE_COMPANY_BANNER_IMAGE.value, deleteCompanyBannerImageSaga);
  yield takeLatest(POST_COMPANY_LOGO_IMAGE.value, postCompanyLogoImageSaga);
  yield takeLatest(DELETE_COMPANY_LOGO_IMAGE.value, deleteCompanyLogoImageSaga);
  yield takeLatest(GET_COMPANY_BY_ID.value, getCompanySaga);
}
